import { useState } from "react";
import { Facebook, Link2, Check } from "lucide-react";
import { API } from "@/lib/api";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.8 22h-6.9l-5.4-7.06L4.3 22H1.04l8.02-9.17L1.2 2h7.07l4.88 6.45L18.24 2Zm-1.21 18h1.8L7.05 3.9H5.12L17.03 20Z" />
  </svg>
);

export const ShareButtons = ({ electorate, count, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const url = `${API}/share/${encodeURIComponent(electorate)}`;
  const text = `${electorate} has ${count} F.E.R.M${count === 1 ? "" : "s"} for The R.O.A.N Initiative. Take your seat:`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const x = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (_) {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const base = compact
    ? "inline-flex items-center justify-center w-9 h-9 rounded-full border transition-colors"
    : "inline-flex items-center gap-2 px-4 h-10 rounded-full border text-sm font-semibold transition-colors";
  const cls = `${base} border-[#FDFBF7]/20 text-[#FDFBF7] hover:border-[#E2705A] hover:bg-[#E2705A]`;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <a href={fb} target="_blank" rel="noopener noreferrer" data-testid="share-facebook-button" className={cls} title="Share on Facebook">
        <Facebook className="w-4 h-4" /> {!compact && "Share on Facebook"}
      </a>
      <a href={x} target="_blank" rel="noopener noreferrer" data-testid="share-x-button" className={cls} title="Share on X">
        <XIcon className="w-4 h-4" /> {!compact && "Post on X"}
      </a>
      <button type="button" onClick={copy} data-testid="share-copy-button" className={cls} title="Copy link">
        {copied ? <Check className="w-4 h-4 text-[#8FA58A]" /> : <Link2 className="w-4 h-4" />} {!compact && (copied ? "Copied" : "Copy link")}
      </button>
    </div>
  );
};
